import React, {useState, useEffect} from "react";
import "./style.css";
import { Container } from '@mui/material';
// image
import logoMarca from '../../images/logo.png';
import {fDateTime} from '../formatTime';
import { fFormataDinheiro } from '../formatNumber';

export default function Layout() {
    const [dados, setDados] = useState([]);
    const [dataDia, setData] = useState('');
    const [descPrincipal, setDescricaoPrincipal] = useState('');
    const [dadosEntrega, setDadosEntrega] = useState([]);
    let dadosImpressao
    let sumValorVenda

    const getItens = async () => { 
        setDados(JSON.parse(localStorage.getItem(['dadosImpressao'])));
        setDadosEntrega(JSON.parse(localStorage.getItem(['dadosEntrega'])));
        const mesa = localStorage.getItem(['mesa']);
        if (mesa !== null) {setDescricaoPrincipal(`** MESA - ${mesa} **`)} else {setDescricaoPrincipal("PEDIDO AVULSO")};
        setData(fDateTime(new Date()));
    };

    useEffect(() => {
        getItens();
    },[]) 



    if ((dadosEntrega.dadosEntrega !== undefined) && (dadosEntrega.dadosEntrega !== '')) {
        dadosImpressao = 
            <Container>
              <table className="printer-ticket">
                  <thead>
                      <th colSpan="3">
                          <img src={logoMarca} alt="logo"/>
                      </th>
                      <tr>
                          <th colSpan="3">{dataDia}</th>
                      </tr>
                      <tr>
                          <th colSpan="3">
                              <b>{descPrincipal}</b> <br />
                          </th>
                      </tr>
                      <tr>
                          <th className="ttu" colSpan="2" align= "left">
                              <b>{dadosEntrega.dadosEntrega}</b>
                          </th>
                      </tr>
                  </thead>
                  <tbody>
                      {Object.values(dados).slice(0, 5).map((item, i ) => {
                          sumValorVenda = dados
                            .reduce((total, item) => {
                                return (total +  item.valor_venda);
                            }, 0);

                          return (
                              <div>
                                  <td colSpan="3"><b>ITEM {i+1}</b></td>
                                  <tr className="top">
                                      <td colSpan="2"><b>Descrição</b></td>
                                      <td align="right">{item.produto}</td>
                                  </tr>
                                  <tr>
                                      <td colSpan="2"><b>Qtde</b></td>
                                      <td align="right">{item.qtde_venda}</td>
                                  </tr>
                                  <tr>
                                      <td colSpan="2"><b>Observação</b></td>
                                      <td align="right">{item.observacao}</td>
                                  </tr>
                                  <tr>
                                      <td colSpan="2"><b>Valor</b></td>
                                      <td align="right">{fFormataDinheiro(item.valor_venda)}</td>
                                  </tr>
                              </div>
                              )	
                          })}       
                  </tbody> 
                  <tfoot>
                      <tr className="sup">
                        <thead>
                            <tr>
                                <td colSpan="2"><b>TOTAL</b></td>
                                <td align="right"><b>{fFormataDinheiro(sumValorVenda)}</b></td>
                            </tr>
                        </thead> 
                      </tr>    
                      <tr className="sup">
                          <td colSpan="3" align="center">
                              meupedidogo.com.br
                          </td>
                      </tr>
                  </tfoot>
              </table> 
          </Container>
    }else{
        dadosImpressao=
            <Container>
              <table className="printer-ticket">
                  <thead>
                      <th colSpan="3">
                          <img src={logoMarca} alt="logo"/>
                      </th>
                      <tr>
                          <th colSpan="3">{dataDia}</th>
                      </tr>
                      <tr>
                          <th colSpan="3">
                              <b>{descPrincipal}</b> <br />
                          </th>
                      </tr>
                      <tr>
                          <th className="ttu" colSpan="3">
                              <b>Itens a serem preparados</b>
                          </th>
                      </tr>
                  </thead>
                  <tbody>
                      {Object.values(dados).slice(0, 5).map((item, i ) => {
                          return (
                              <div>
                                  <td colSpan="3"><b>ITEM</b></td>
                                  <tr className="top">
                                      <td colSpan="2"><b>Descrição</b></td>
                                      <td align="right">{item.produto}</td>
                                  </tr>
                                  <tr>
                                      <td colSpan="2"><b>Qtde</b></td>
                                      <td align="right">{item.qtde_venda}</td>
                                  </tr>
                                  <tr>
                                      <td colSpan="2"><b>Observação</b></td>
                                      <td align="right">{item.observacao}</td>
                                  </tr>
                              </div>
                              )	
                          })}       
                  </tbody> 
                  <tfoot>
                      <tr className="sup">
                          <td colSpan="3" align="center">
                              meupedidogo.com.br
                          </td>
                      </tr>
                  </tfoot>
              </table> 
          </Container>
    }
    return dadosImpressao
}